module.exports = __webpack_public_path__ + "media/images/front/not-logged-in-lp/xximg_intro_list01-b28e9176d180d22aef9600454aecff27.png";